import MainLayout from "./MainLayout";
import styles from "../assets/styles/HomePage.module.css";
import styels2 from "../assets/styles/HomePage2.module.css";
import "../assets/styles/styles.css";
import { Helmet } from "react-helmet";
import Banner from "../assets/images/banner.svg";
import understand from "../assets/images/understand.svg";
import design from "../assets/images/design.svg";
import implement from "../assets/images/implement.svg";
import HeroSection from "../compenents/HeroSection";
import React, { useState, useEffect, useRef } from "react";
import HeroSection223 from "./HeroSection223";
import NewSkills from "../compenents/NewSkills"
// AboutMeSection
import AboutMeSection from "../compenents/AboutMeSection"
import OpenToWork from "../compenents/OpenToWork";
import Workflow2 from "../compenents/Workflow2";
import LatestProject2 from "../compenents/LatestProject2";
import TopProjectTV2 from "../compenents/TopProjectTV2";
import JustLawProject from "../compenents/Justlaw";
import { Send, ArrowRight } from "lucide-react";
import { useInView } from "react-intersection-observer";

//     const realName = process.env.REACT_APP_REALNAME

export default function Home() {
  const [activeSection, setActiveSection] = useState(1);

  const { ref: heroRef, inView: heroInView } = useInView({ threshold: 0.1 });
  const { ref: workflowRef, inView: workflowInView } = useInView({ threshold: 0.1 });
  const { ref: projectRef, inView: projectInView } = useInView({ threshold: 0.1 });
  const { ref: openToWorkRef, inView: openToWorkInView } = useInView({ threshold: 0.1 });
  const { ref: newSkillsRef, inView: newSkillsInView } = useInView({ threshold: 0.1 });
  const { ref: aboutRed, inView: aboutInView } = useInView({ threshold: 0.1 });

  useEffect(() => {
    if (heroInView) setActiveSection(1);
    else if (workflowInView) setActiveSection(2);
    else if (projectInView) setActiveSection(3);
    else if (openToWorkInView) setActiveSection(4);
    else if (newSkillsInView) setActiveSection(5);
    else if (aboutInView) setActiveSection(6);
  }, [heroInView, workflowInView, projectInView, openToWorkInView, newSkillsInView, aboutInView]);

  return (
    <MainLayout>
      <div className={styles.pageWrapper}>
      <Helmet>
        <title>Home</title>
      </Helmet>

{/* Navigation dots */}
      <div className={styles.navDots}>
        {[1, 2, 3, 4, 5, 6].map((num) => (
          <span
            key={num}
            className={`${styles.dot} ${activeSection === num ? styles.activeDot : ""}`}
          />
        ))}
      </div>
      <section ref={heroRef}>
        <HeroSection223 />
      </section>

      <section ref={workflowRef}>
        <Workflow2 />
      </section>

      <section ref={projectRef}>
          <LatestProject2/>
          <TopProjectTV2/>
          <JustLawProject/>
      </section>

  <section ref={openToWorkRef}>
            <OpenToWork/>
  </section>

  <section ref={newSkillsRef}>
                        <NewSkills/>
  </section>

  <section ref={aboutRed}>
            <AboutMeSection/>
  </section>
  
</div>
    </MainLayout>
  );
}

function Home2() {
    return (
        <MainLayout>
            <Helmet>
                <title>Home</title>
            </Helmet>
            <HeroSection223/>
            <Workflow2/>
            <LatestProject2/>
            <TopProjectTV2/>
            <JustLawProject/>
            <OpenToWork/>
            <NewSkills/>
            <AboutMeSection/>
        </MainLayout>
    );
}



const TopProjectTV = () => {
  const [visible, setVisible] = useState(false);
  const tvRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { threshold: 0.3 } // trigger when 30% visible
    );

    if (tvRef.current) observer.observe(tvRef.current);

    return () => observer.disconnect();
  }, []);

  const capsules = [
    { label: "Deployed", color: "#18c629ff", bg: "rgba(24,198,41,0.1)" },
    { label: "Client: Multinational Food Platform", color: "#555", bg: "rgba(0,0,0,0.03)" },
    { label: "Private • Demo can be shared privately under NDA", color: "#d63384", bg: "rgba(214,51,132,0.05)" },
  ];

  const sections = [
    {
      title: "What it does",
      description: "A distributed system controlling Android TVs across multiple countries, forming a synchronized video wall. It handles screen capture, playlist assignments for individual TVs or groups, and real-time monitoring."
    },
    {
      title: "How it works",
      description: "Syncs multiple TVs without any specialized hardware, achieving sub-30ms latency. Activation is simple: install the Android client app, scan a QR code from the dashboard on a phone, and you’re ready to go."
    },
    {
      title: "Dashboard & Backend",
      description: "Built with SQL, Python, FastAPI, ReactJS, and React Native. Supports 15,000–18,000 TVs simultaneously at a cost of ~$20/month, ensuring high scalability and reliability."
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "80px 20px",
        maxWidth: "1200px",
        margin: "0 auto",
        gap: "40px",
      }}
    >


      {/* Right side: TV mockup */}
      <div
        style={{
          flex: "1 1 300px",
          minWidth: "300px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          ref={tvRef}
          style={{
            width: "420px",
            aspectRatio: "16 / 9",
            borderRadius: "12px",
            border: "2px solid #ccc",
            position: "relative",
            boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
            backgroundColor: "#000",
            transform: visible ? "translateY(0px)" : "translateY(50px)",
            opacity: visible ? 1 : 0,
            transition: "all 1s ease-out",
          }}
        >
          {/* Screen placeholder */}
          <div
  style={{
    position: "absolute",
    inset: "8px",
    borderRadius: "8px",
    backgroundColor: "#1a1a1a",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    padding: "20px",
    textAlign: "center",
  }}
>
  <p style={{ marginBottom: "24px", fontWeight: "600", fontSize: "1.1rem" }}>
    Private
  </p>
  
  <a
    style={{
      padding: "14px 32px",
      fontSize: "1rem",
      border: "none",
      borderRadius: "96px",
      backgroundColor: "#fff", // inverted colors
      color: "#2b213b",
      cursor: "pointer",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      transition: "transform 0.3s ease, background-color 0.3s ease",
              textDecoration: "none",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    // onClick={() => alert("Reach out for demo clicked!")}
      href="https://calendly.com/orinomohamed/new-meeting"
  target="_blank"
  rel="noopener noreferrer"
  >
    Book a Call
    {/* Arrow in a circle */}
    <span
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        border: "2px solid #2b213b",
      }}
    >
      {/* <span
        style={{
          display: "block",
          width: "8px",
          height: "2px",
          backgroundColor: "#2b213b",
          transform: "translateX(4px) rotate(0deg)",
        }}
      /> */}
      <ArrowRight size={12} color="#2b213b" />
    </span>
  </a>
</div>

          {/* TV Legs */}
          <div
            style={{
              position: "absolute",
              bottom: "-20px",
              left: "50%",
              width: "160px",
              height: "4px",
              backgroundColor: "#333",
              borderRadius: "2px",
              transform: "translateX(-50%) rotate(15deg)",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              bottom: "-20px",
              left: "50%",
              width: "160px",
              height: "4px",
              backgroundColor: "#333",
              borderRadius: "2px",
              transform: "translateX(-50%) rotate(-15deg)",
            }}
          ></div>
        </div>
      </div>
            {/* Left side: Text */}
      <div style={{ flex: "1 1 400px", minWidth: "300px" }}>
        <h2 style={{ fontSize: "2rem", fontWeight: "700", marginBottom: "20px" }}>
          Top Project • Global Video Wall Platform
        </h2>

        {/* Capsules */}
        <div style={{ display: "flex", gap: "10px", marginBottom: "20px", flexWrap: "wrap" }}>
          {capsules.map((cap, idx) => (
            <span
              key={idx}
              style={{
                padding: "4px 12px",
                border: `1px solid ${cap.color}`,
                borderRadius: "999px",
                fontSize: "0.875rem",
                fontWeight: "600",
                color: cap.color,
                backgroundColor: cap.bg,
              }}
            >
              {cap.label}
            </span>
          ))}
        </div>

        {/* Sections */}
        {sections.map((sec, idx) => (
          <div key={idx} style={{ marginBottom: "20px" }}>
            <h3 style={{ fontSize: "1.25rem", fontWeight: "700", marginBottom: "8px" }}>{sec.title}</h3>
            <p style={{ fontSize: "1rem", color: "#555", lineHeight: "1.6" }}>{sec.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const LatestProject = () => {
  const capsules = [
    { label: "MVP: Lunching SOON", color: "#007bff", bg: "rgba(0,123,255,0.05)" },
    { label: "Client: Mohammed Eleouja & Jirayr Melikyan", color: "#555", bg: "rgba(0,0,0,0.03)" },
    { label: "Private • Source code can be shared privately", color: "#d63384", bg: "rgba(214,51,132,0.05)" },
  ];

  const sections = [
    {
      title: "What it does",
      description: "Tracks current and upcoming flights, saves your journeys, provides detailed statistics including past flights, and sends notifications for delays, gate changes, and terminal updates."
    },
    {
      title: "How it works",
      description: "Syncs data from the backend with SQL and FastAPI (Python). Provides smooth navigation, real-time updates, and offline caching for seamless user experience."
    },
    {
      title: "Frontend & Backend",
      description: "Frontend: SwiftUI + Core Data. Backend: SQL + FastAPI (Python). Focused on high performance, reliability, and maintainable architecture."
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        padding: "80px 20px",
        maxWidth: "1200px",
        margin: "0 auto",
        gap: "40px",
      }}
    >
      {/* Left side: Text */}
      <div style={{ flex: "1 1 400px", minWidth: "300px" }}>
        <h2 style={{ fontSize: "2rem", fontWeight: "700", marginBottom: "20px" }}>
          Latest Project • Flight Tracker (iOS)
        </h2>

        {/* Capsules */}
        <div style={{ display: "flex", gap: "10px", marginBottom: "20px", flexWrap: "wrap" }}>
          {capsules.map((cap, idx) => (
            <span
              key={idx}
              style={{
                padding: "4px 12px",
                border: `1px solid ${cap.color}`,
                borderRadius: "999px",
                fontSize: "0.875rem",
                fontWeight: "600",
                color: cap.color,
                backgroundColor: cap.bg,
              }}
            >
              {cap.label}
            </span>
          ))}
        </div>

        {/* Sections */}
        {sections.map((sec, idx) => (
          <div key={idx} style={{ marginBottom: "20px" }}>
            <h3 style={{ fontSize: "1.25rem", fontWeight: "700", marginBottom: "8px" }}>{sec.title}</h3>
            <p style={{ fontSize: "1rem", color: "#555", lineHeight: "1.6" }}>{sec.description}</p>
          </div>
        ))}
      </div>

      {/* Right side: iPhone mockup */}
      <div
        style={{
          flex: "1 1 300px",
          minWidth: "250px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "250px",
            aspectRatio: "9 / 19.5",
            borderRadius: "40px",
            border: "1.5px solid #ccc",
            position: "relative",
            boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
            backgroundColor: "#fff",
          }}
        >
          {/* Screen placeholder */}
          <div
            style={{
              position: "absolute",
              inset: "6px",
              borderRadius: "30px",
              backgroundColor: "#f0f0f0",
            }}
          >
            <video
  src="https://my-video-assests.s3.eu-north-1.amazonaws.com/Untitled33.m4v"
  autoPlay
  loop
  muted
  playsInline
  style={{
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "inherit",
  }}
/>
            {/* Video or app screenshot can go here */}
          </div>
        </div>
      </div>
    </div>
  );
};

const WorkFlow = () => {
  const steps = [
    {
      title: "Understand Your Challenge",
      description: "Will take the time to listen and grasp your unique needs.",
      image: understand,
    },
    {
      title: "Design the Solution",
      description: "Craft a practical, reliable solution with clean architecture and attention to testing from the start.",
      image: design,
    },
    {
      title: "Bring It to Life",
      description: "Implement and deliver software that works smoothly, scales well, and meets the original vision without surprises.",
      image: implement,
    },
  ];

  // Reusable styles
  const sectionStyle = {
    width: "100%",
    padding: "80px 20px", // extra top padding for header
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    flexDirection: "column", // stack header and workflow container
    alignItems: "center",
  };

  const headerStyle = {
    fontSize: "2.5rem",
    fontWeight: "700",
    marginBottom: "40px",
    textAlign: "center",
    color: "#222",
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    gap: "40px",
    maxWidth: "1200px",
    width: "100%",
    flexWrap: "wrap",
  };

  const cardStyle = {
    flex: "1 1 300px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    textAlign: "center",
    padding: "20px",
    boxSizing: "border-box",
  };

  const imgStyle = {
    width: "150px",
    height: "150px",
    objectFit: "contain",
  };

  const titleStyle = {
    fontSize: "1.5rem",
    fontWeight: "700",
  };

  const descStyle = {
    fontSize: "1rem",
    color: "#555",
    lineHeight: "1.5",
  };

  return (
    <div style={sectionStyle}>
      {/* Section header */}
      <h2 style={{ fontSize: "2rem", fontWeight: "700", marginBottom: "20px" }}>Our Work Process</h2>

      {/* Workflow cards */}
      <div style={containerStyle}>
        {steps.map((step, index) => (
          <div key={index} style={cardStyle}>
            <img src={step.image} alt={step.title} style={imgStyle} />
            <h3 style={titleStyle}>{index + 1}. {step.title}</h3>
            <p style={descStyle}>{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const HeroSection2 = () => {
  const [animate, setAnimate] = useState(false);
  const words = ["Fast", "Reliable", "Scalable", "Innovative"];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [fade, setFade] = useState(true); // controls fade-in/out

  useEffect(() => {
    setAnimate(true);
    const interval = setInterval(() => {
      setFade(false); // trigger fade out
      setTimeout(() => {
        setCurrentWordIndex((prev) => (prev + 1) % words.length);
        setFade(true); // fade in new word
      }, 500); // match animation duration
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  const textStyle = (delay) => ({
    transition: "all 1s ease",
    opacity: animate ? 1 : 0,
    transform: animate ? "translateY(0px)" : "translateY(20px)",
    transitionDelay: delay,
  });

  const wordStyle = {
    display: "inline-block",
    color: "#007bff",
    transition: "all 0.5s ease",
    opacity: fade ? 1 : 0,
    transform: fade ? "translateY(0px)" : "translateY(-20px)",
  };

  const circleStyle = (size, top, left, delay) => ({
    position: "absolute",
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: "rgba(0, 123, 255, 0.15)",
    top,
    left,
    filter: "blur(20px)",
    animation: `float 6s ease-in-out infinite`,
    animationDelay: delay,
  });

  return (
    <div
      style={{
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        padding: "0 20px",
        fontFamily: "sans-serif",
      }}
    >
      {/* Floating circles */}
      <div style={circleStyle("100px", "10%", "15%", "0s")}></div>
      <div style={circleStyle("150px", "70%", "80%", "2s")}></div>
      <div style={circleStyle("80px", "40%", "60%", "4s")}></div>

      {/* Hero Text */}
      <span
        style={{
          ...textStyle("0.2s"),
          fontSize: "1rem",
          fontWeight: "600",
          color: "#555",
          marginBottom: "10px",
        }}
      >
        Mohammed Elaouja
      </span>

      <h1
        style={{
          ...textStyle("0.4s"),
          fontSize: "3rem",
          marginBottom: "20px",
          fontWeight: "700",
          lineHeight: "1.2",
        }}
      >
        <span style={wordStyle}>{words[currentWordIndex]}</span> Solutions, for Your Needs
      </h1>

      <p
        style={{
          ...textStyle("0.6s"),
          fontSize: "1.25rem",
          marginBottom: "40px",
          maxWidth: "600px",
          color: "#333",
          lineHeight: "1.6",
        }}
      >
       I craft reliable and efficient software solutions, combining hands-on development with a QA-driven mindset. Let’s build something great together.
      </p>

      {/* <button
        style={{
          ...textStyle("0.8s"),
          padding: "14px 32px",
          fontSize: "1rem",
          border: "none",
          borderRadius: "96px",
          backgroundColor: "#2b213b",
          color: "#fff",
          cursor: "pointer",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        //   transition: "transform 0.3s ease, background-color 0.3s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        onClick={() => alert("CTA Clicked!")}
      >
        Get In Touch
      </button> */}
      <a
      href={`mailto:orinomohamed@gmail.com`}
  style={{
    ...textStyle("0.8s"),
    padding: "14px 32px",
    fontSize: "1rem",
    border: "none",
    borderRadius: "96px",
    backgroundColor: "#2b213b",
    color: "#fff",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    transition: "transform 0.3s ease, background-color 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "12px", // spacing between icon and text
    textDecoration: "None",
  }}
  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
//   onClick={() => alert("CTA Clicked!")}
>
    <Send color="#fff" size={16} />
  
  Get In Touch
</a>

      {/* Floating animation keyframes */}
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
        `}
      </style>
    </div>
  );
};